import apiClient from "./axiosInstanceCourier";

export const createCourier = async (courierData) => {
  return await apiClient.post("/api/v1/couriers", courierData);
};

export const getCouriers = async () => {
  return await apiClient.get("/v1/couriers");
};

export const getCourierById = async (id) => {
  if (!id) {
    throw new Error('Courier ID is required');
  }
  return await apiClient.get(`/v1/couriers/${id}`);
};

export const getCourierByUserId = async (userId) => {
  if (!userId) {
    throw new Error('Courier user ID is required');
  }
  return await apiClient.get(`/v1/couriers1/${userId}`);
};

export const getAllOrders = async () => {
  return await apiClient.get("/api/v1/orders");
};

export const getRecentOrders = async () => {
  return await apiClient.get("/api/v1/orders/recent");
};
